import { render, staticRenderFns } from "./bodega-el-esterco.vue?vue&type=template&id=07eae7b7&scoped=true"
import script from "./bodega-el-esterco.vue?vue&type=script&lang=js"
export * from "./bodega-el-esterco.vue?vue&type=script&lang=js"
import style0 from "./bodega-el-esterco.vue?vue&type=style&index=0&id=07eae7b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eae7b7",
  null
  
)

export default component.exports